import { REACT_ROUTES } from 'App/constants'

const getTitleLabels = (fullPath): any => {
  return fullPath
    .split('/')
    .filter((val) => !!val)
    .reduce(
      ({ path, titles }, pathPart) => {
        const pathToCheck = `${path}/${pathPart}`

        const currentPageKey = Object.keys(REACT_ROUTES).find(
          (key) =>
            REACT_ROUTES[key].path === pathToCheck || REACT_ROUTES[key].reroutePath === pathToCheck,
        )

        // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
        if (REACT_ROUTES[currentPageKey]?.title) {
          return {
            path: pathToCheck,
            // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
            titles: [REACT_ROUTES[currentPageKey].title, ...titles],
          }
        }

        return {
          path: pathToCheck,
          titles: [...titles],
        }
      },
      { path: '', titles: [] },
    )
}

export default getTitleLabels
